import {registerSimpleNativeProperties} from "@plaudit/gutenberg-api-extensions";

registerSimpleNativeProperties({
	block: 'core/search',
	properties: [
		{
			label: "Local Search",
			name: "local_search",
			help: "Causes the search action to set a parameter on the current URL instead of loading the site-search page",
			control: 'toggle',
			switch: {small: true},
			default: false
		},
		{
			label: "Omit Taxonomy Term",
			name: "omit_taxonomy_term",
			help: "Makes Local Search always run against all posts of the current Post Type instead of just those matching the current Taxonomy Term",
			control: 'toggle',
			switch: {small: true},
			default: false,
			condition: [{op: "==", property: "local_search", value: true}]
		},
		{
			label: "For Alternate Query",
			name: "for_alternate_query",
			help: "Makes the search parameter apply to a named query",
			control: 'toggle',
			switch: {small: true},
			default: false,
			condition: [{op: "==", property: "local_search", value: true}]
		},
		{
			label: "Alternate Query Name",
			name: "alternate_query_name",
			help: "The name of the query to which the search should apply. A search field configured to point to this query must also appear on the page containing the query.",
			control: "text",
			condition: [{op: "==", property: "for_alternate_query", value: true}]
		}
	]
});
